import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { calculateAge } from '../../../utility/utilities';
import Url from '../../../data/url';
import { useUserStore } from '../../../store/useUserStore';
import ImgKidFace from '../../../assets/image/img_kidface.png';
import IcPlus from '../../../assets/image/ic_plus.svg';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';
import { Kid } from '../../../types';
import { useTranslation } from '../../../hook/useTranslation';

interface KidBoxProps {
  kid: Kid & { imageUrl?: string };
  pressed: number | null;
  onClick?: (kid: Kid & { imageUrl?: string }) => void;
  setPressed?: (id: number | null) => void;
}

function KidBox({ kid, pressed }: KidBoxProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div
      className="flex items-center justify-start w-full gap-3 px-[20px]"
      style={{
        backgroundColor: pressed === kid?.id ? '#F2F2F2' : '#FFF',
      }}
    >
      <div className="min-w-[52px] min-h-[52px] overflow-hidden bg-[#FFF] border border-[#EAEAEA] flex items-center justify-center rounded-[24px]">
        {kid.imageUrl ? (
          <img src={kid.imageUrl} alt="thumnail1" className="w-[52px] h-[52px]" />
        ) : (
          <img src={ImgKidFace} alt="thumnail1" className="w-[30px] h-[30px]" />
        )}
      </div>
      <div className="grow flex flex-col items-start my-[12px]">
        <div className="flex items-center cursor-pointer gap-[5px]">
          <span className="font-[700] text-[16px]">{kid?.kidName ?? '-'}</span>
        </div>
        <div className="text-[12px] font-[400] text-[#363636]">
          {kid?.gender === 'male' ? t('home.male') : t('home.female')}•{t('common.age', { age: calculateAge(kid?.kidBirth) })}
        </div>
      </div>
      <button
        type="button"
        onClick={() => navigate(Url.MyKidProfile, { state: { kid } })}
        className="text-[#5EBEBB] border border-[#E0E0E0] rounded-[5px] font-[600] text-[12px] w-[76px] h-[30px]"
      >
        {t('my.profile.edit_title')}
      </button>
    </div>
  );
}

export default function KidsManagePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const user = useUserStore();
  const setUser = user.setUser;
  const [pressed, setPressed] = useState<number | null>(null);

  const handleDecideMainKid = (kid: Kid & { imageUrl?: string }) => {
    setUser((prev) => ({
      ...prev,
      mainKid: kid,
    }));
    navigate(-1);
  };

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev title={t('my.profile.manage_kids')} onClickPrev={() => navigate(-1)} />
      <div className="pageInner bg-[#FFF]">
        <div
          className="flex flex-col items-start justify-start gap-3 mt-[20px]"
          style={{ width: '100vw', marginLeft: '-23px', marginRight: '-23px' }}
        >
          {user?.kids &&
            user.kids.length >= 1 &&
            user.kids.map((kid, index) => (
              <KidBox
                key={`${kid?.id}-${String(index)}`}
                kid={kid as Kid & { imageUrl?: string }}
                onClick={handleDecideMainKid}
                pressed={pressed}
                setPressed={setPressed}
              />
            ))}
        </div>
        <div className="flex flex-col items-start justify-start w-full gap-3 mt-[20px]">
          <button
            type="button"
            className="flex items-center justify-start w-full gap-3 cursor-pointer"
            onClick={() => navigate(Url.KidsRegister)}
          >
            <div
              className="min-w-[52px] min-h-[52px] bg-[#FFF] border border-[#EAEAEA] flex items-center justify-center rounded-[24px]"
              style={{
                borderRadius: '20px',
                border: '2px dashed var(--devider-devider-1, #C6C6C6)',
              }}
            >
              <img src={IcPlus} alt="thumnail1" className="w-[9px] h-[9px]" />
            </div>
            <div className="grow flex flex-col items-start my-[12px]">
              <div className="font-[700] text-[16px]">{t('home.change_kid.add_kid')}</div>
            </div>
          </button>
        </div>
      </div>
    </FullHeightContainer>
  );
}
